import { CasinoForm } from './form';

import { PromoPackTypeEnum } from 'v2/types/CasinoModel';

export function replaceEmptyStringsWithNull(values: CasinoForm): CasinoForm {
  const benefits =
    values.benefits.promoPackType === PromoPackTypeEnum.STANDARD
      ? {
          promoPackType: PromoPackTypeEnum.STANDARD,
          freeSpinsCount: values.benefits.freeSpinsCount || null,
          depositPercentage: values.benefits.depositPercentage || null,
          customPromo: null,
        }
      : {
          promoPackType: PromoPackTypeEnum.CUSTOM,
          freeSpinsCount: null,
          depositPercentage: null,
          customPromo: values.benefits.customPromo ?? null,
        };

  return {
    ...values,
    benefits,
    logoVerticalId: values.logoVerticalId === '' ? null : values.logoVerticalId,
    logoSquareId: values.logoSquareId === '' ? null : values.logoSquareId,
  };
}
